import resolveRequest from '../../utils/resolveRequest.js'
import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async (id) => {
  const endpoint = `${apiEndpoints.organizations}/${id}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.delete(URL, { withCredentials: true }))
}
